/* ICON STADIUM — storefront behaviour */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'icon-cart-drawer';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function lock(on) { document.documentElement.classList.toggle('ic-lock', on); }

  function toast(msg) {
    var t = $('.ic-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ic ic-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Cart drawer ---------- */
  function drawer() { return $('[data-ic-cart]'); }
  function openCart() {
    var d = drawer(); if (!d) return false;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lock(true);
    var c = $('[data-ic-cart-close].ic-icon-btn', d); if (c) c.focus({ preventScroll: true });
    return true;
  }
  function closeCart() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lock(false);
  }
  function setCount(n) { $$('[data-ic-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }

  function refreshCart(open) {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-ic-cart]', doc), cur = drawer();
        if (fresh && cur) {
          var wasOpen = cur.classList.contains('is-open');
          var body = $('.ic-cart__body', cur), y = body ? body.scrollTop : 0;
          cur.innerHTML = fresh.innerHTML;
          if (wasOpen || open) { cur.classList.add('is-open'); cur.setAttribute('aria-hidden', 'false'); lock(true); }
          var nb = $('.ic-cart__body', cur); if (nb) nb.scrollTop = y;
        }
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) setCount(cart.item_count); });
  }

  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(true); })
      .then(function () {
        if (!drawer()) { window.location.href = root + 'cart'; }
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1200); }
      })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add to cart'); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function changeLine(line, qty) {
    var d = drawer(); if (d) d.classList.add('is-busy');
    return fetch(root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty)) })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(false); })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not update cart'); })
      .then(function () { var x = drawer(); if (x) x.classList.remove('is-busy'); });
  }

  /* ---------- Mobile menu ---------- */
  function menu(open) {
    var m = $('[data-ic-mmenu]'); if (!m) return;
    m.classList.toggle('is-open', open); m.setAttribute('aria-hidden', open ? 'false' : 'true'); lock(open);
  }

  /* ---------- Global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    var el;
    if ((el = t.closest('[data-ic-cart-open]'))) { if (openCart()) e.preventDefault(); return; }
    if (t.closest('[data-ic-cart-close]')) { closeCart(); return; }
    if (t.closest('[data-ic-menu-open]')) { menu(true); return; }
    if (t.closest('[data-ic-menu-close]')) { menu(false); return; }
    if ((el = t.closest('[data-ic-quick]'))) { e.preventDefault(); addToCart(el.getAttribute('data-ic-quick'), 1, el); return; }
    if ((el = t.closest('[data-ic-qty]'))) { changeLine(el.getAttribute('data-ic-qty'), el.getAttribute('data-q')); return; }
    if ((el = t.closest('[data-ic-upsell-add]'))) {
      var sel = $('[data-ic-upsell-select]', el.parentElement);
      if (sel) addToCart(sel.value, 1, el);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); menu(false); } });

  /* ---------- Announcement rotation ---------- */
  $$('[data-ic-announce]').forEach(function (bar) {
    var items = $$('.ic-announce__item', bar); if (items.length < 2) return;
    var i = 0, ms = (Number(bar.getAttribute('data-speed')) || 5) * 1000;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, ms);
  });

  /* ---------- Product page ---------- */
  function money(cents) {
    var fmt = (window.icMoneyFormat || '${{amount}}');
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, parts.join('.')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(',')).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  $$('[data-ic-pdp]').forEach(function (pdp) {
    var dataEl = $('[data-ic-variants]', pdp);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $('[data-ic-form]', pdp);
    var idInput = form && $('input[name="id"]', form);
    var addBtn = $('[data-ic-add]', pdp);
    var sizesWrap = $('[data-ic-sizes]', pdp);
    var msg = $('[data-ic-msg]', pdp);
    var selName = $('[data-ic-selected]', pdp);
    var sticky = $('[data-ic-sticky]');
    var stickyBtn = sticky && $('[data-ic-sticky-add]', sticky);
    var chosen = null;

    function label(text, disabled) {
      if (addBtn) { addBtn.textContent = text; addBtn.classList.toggle('is-disabled', !!disabled); }
      if (stickyBtn) stickyBtn.textContent = text;
    }
    function renderPrice(v) {
      $$('[data-ic-price]', document).forEach(function (p) {
        if (!p.closest('[data-ic-pdp]') && !p.closest('[data-ic-sticky]')) return;
        var now = $('[data-ic-price-now]', p), was = $('[data-ic-price-was]', p), save = $('[data-ic-price-save]', p);
        if (now) now.textContent = money(v.price);
        if (was) was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        if (save) save.style.display = v.compare_at_price > v.price ? '' : 'none';
      });
    }
    function select(v) {
      chosen = v;
      if (idInput) idInput.value = v.id;
      if (selName) selName.textContent = v.title;
      if (msg) msg.textContent = '';
      if (sizesWrap) sizesWrap.classList.remove('is-warn');
      renderPrice(v);
      label(v.available ? 'Add to cart' : 'Sold out', !v.available);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
    function warn() {
      if (msg) msg.textContent = 'Please select a size';
      if (sizesWrap) { sizesWrap.classList.remove('is-warn'); void sizesWrap.offsetWidth; sizesWrap.classList.add('is-warn'); sizesWrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }

    if (sizesWrap) {
      sizesWrap.addEventListener('change', function (e) {
        var id = Number(e.target.value);
        var v = variants.filter(function (x) { return x.id === id; })[0];
        if (v) select(v);
      });
      var pre = $('input:checked', sizesWrap);
      if (pre) { var pv = variants.filter(function (x) { return x.id === Number(pre.value); })[0]; if (pv) select(pv); }
    } else if (variants.length === 1) { chosen = variants[0]; }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!chosen) { warn(); return; }
        if (!chosen.available) return;
        var qtyEl = $('input[name="quantity"]', form);
        addToCart(chosen.id, qtyEl ? Number(qtyEl.value) || 1 : 1, addBtn);
      });
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!chosen) { warn(); return; }
        if (chosen.available) addToCart(chosen.id, 1, stickyBtn);
      });
    }
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(addBtn);
    }

    /* Gallery */
    var main = $('[data-ic-main]', pdp);
    $$('[data-ic-thumb]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var img = main && $('img', main); if (!img) return;
        img.src = b.getAttribute('data-src'); img.srcset = b.getAttribute('data-srcset') || '';
        $$('[data-ic-thumb]', pdp).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        main.classList.remove('is-zoom');
      });
    });
    if (main && window.matchMedia('(hover:hover)').matches) {
      main.addEventListener('click', function () { main.classList.toggle('is-zoom'); });
      main.addEventListener('mousemove', function (e) {
        if (!main.classList.contains('is-zoom')) return;
        var r = main.getBoundingClientRect(), img = $('img', main);
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    }

    /* Size guide */
    var guideBtn = $('[data-ic-guide-open]', pdp), guide = $('[data-ic-guide]');
    if (guideBtn && guide && guide.showModal) {
      guideBtn.addEventListener('click', function () { guide.showModal(); });
      $$('[data-ic-guide-close]', guide).forEach(function (b) { b.addEventListener('click', function () { guide.close(); }); });
      guide.addEventListener('click', function (e) { if (e.target === guide) guide.close(); });
    }
  });

  /* Collection sort */
  $$('[data-ic-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Newsletter success message */
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    var nm = $('[data-ic-news-msg]'); if (nm) nm.textContent = 'Thanks for joining. Welcome to the club.';
  }

  window.IconStadium = { openCart: openCart, refreshCart: refreshCart, addToCart: addToCart };
})();
